const WHATSAPP_NUMBER = "447486160965";

// Opens WhatsApp with the message already typed in, so the studio knows why
// the person is getting in touch. They can edit it before sending.
export function whatsappLink(message) {
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${WHATSAPP_NUMBER}${text}`;
}

export const WHATSAPP_MESSAGES = {
  general: "Hello Kinews Studio, I'd like to make an enquiry.",
  booking: "Hello Kinews Studio, I'd like to book a photography session.",
  events: "Hello Kinews Studio, I'd like to enquire about event photography.",
  printing: "Hello Kinews Studio, I'd like to enquire about printing.",
  rental: "Hello Kinews Studio, I'd like to enquire about hiring the studio.",
  team: "Hello Kinews Studio, I'd like to speak to your team.",
};
